'use client';
import Highlight from "./Highlight.js";
export default Highlight;